import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { Chart } from "@local-logic/core/ui";

export const IncomeBrackets = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { income_level: incomeLevel },
  } = useDemographics();

  const dataset = useMemo(
    () => ({
      labels: incomeLevel?.variables.map((variable) => variable.label) || [],
      data:
        incomeLevel?.variables.map((variable) =>
          Number((variable.value * 100).toFixed(1))
        ) || [],
    }),
    [incomeLevel?.variables]
  );

  const chartOptions = useMemo(
    () => ({
      title: t("data.income.graphs.incomeBrackets.title"),
      labels: dataset.labels,
      data: dataset.data,
      unit: "%",
    }),
    [dataset]
  );

  return (
    <Chart.Root {...chartOptions}>
      <Chart.BarChart />
    </Chart.Root>
  );
};
